import React from 'react';
import PropTypes from 'prop-types';

import FormatGraphDataService from 'components/year-review/services/FormatGraphDataService';

const YRCustomPieLegend = ({ payload, style }) => {
    const unit = style && style.unit;

    return (
        <div className="yr-custom-pie-legend">
            <ul>
                {
                    payload.map((payloadObj) => {
                        const { name, values, fill } = payloadObj.payload.payload;

                        return (
                            <li className="yr-custom-pie-legend__item" key={name}>
                                <svg className="yr-custom-pie-legend__circle" viewBox="0 0 32 32" version="1.1">
                                    <path fill={fill} transform="translate(16, 16)" d="M16,0A16,16,0,1,1,-16,0A16,16,0,1,1,16,0" />
                                </svg>
                                <b>{name}</b>&nbsp;
                                {FormatGraphDataService.twoDecimalPlaces(values)}
                                {unit}
                            </li>
                        );
                    })
                }
            </ul>
        </div>
    );
};

YRCustomPieLegend.defaultProps = {
    payload: [],
    style: {},
};

YRCustomPieLegend.propTypes = {
    payload: PropTypes.arrayOf(PropTypes.object),
    style: PropTypes.objectOf(PropTypes.any),
};

export default YRCustomPieLegend;
